import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { ArrowBendUpRight } from "@phosphor-icons/react";

export const ST = { draft: "Brouillon", sending: "Envoi en cours", sent: "Envoyée" };
export const FU_ST = { scheduled: "programmée", sending: "en cours", sent: "envoyée", cancelled: "annulée", error: "en erreur" };
export const OUTCOMES = { replied_interested: "A répondu — intéressé", replied_not_interested: "A répondu — pas intéressé", replied: "A répondu", opt_out: "Opposition (STOP)" };

export function FollowupForm({ fu, setFu }) {
  return (
    <div className="border border-border rounded-md p-3 space-y-2" data-testid="lead-followup-form">
      <label className="flex items-center gap-2 text-xs text-fg">
        <input type="checkbox" checked={fu.enabled} onChange={(e) => setFu({ ...fu, enabled: e.target.checked })} data-testid="lead-followup-enabled" />
        Programmer une relance si le prospect n'a pas répondu
      </label>
      {fu.enabled && (
        <>
          <div className="flex items-center gap-2 text-xs"><span className="text-muted">Relance après</span>
            <input type="number" min="2" max="30" value={fu.delay_days} onChange={(e) => setFu({ ...fu, delay_days: e.target.value })} className="bg-surface-2 border border-border rounded px-2 py-1 w-16" data-testid="lead-followup-delay" />
            <span className="text-muted">jours</span></div>
          <Input className="bg-surface-2 border-border text-xs h-8" value={fu.subject} onChange={(e) => setFu({ ...fu, subject: e.target.value })} data-testid="lead-followup-subject" />
          <Textarea className="bg-surface-2 border-border font-mono text-[11px] min-h-[110px]" value={fu.body_html} onChange={(e) => setFu({ ...fu, body_html: e.target.value })} data-testid="lead-followup-body" />
          <p className="text-[10px] text-muted">Jamais envoyée à un prospect ayant répondu, opposé, exclu ou dont le statut a évolué.</p>
        </>
      )}
    </div>
  );
}

export function FollowupStatus({ c, reload }) {
  const f = c.followup;
  if (!f) return null;
  const cancel = async () => { try { await api.post(`/admin/leads/campaigns/${c.id}/followup/cancel`); toast.success("Relance annulée"); reload(); } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } };
  return (
    <div className="text-xs border border-accent/30 bg-accent/[0.05] rounded-md p-3 flex flex-wrap items-center justify-between gap-2" data-testid="lead-followup-status">
      <span className="flex items-center gap-1.5"><ArrowBendUpRight size={13} className="text-accent" /> Relance {FU_ST[f.status] || f.status} · J+{f.delay_days} ({new Date(f.due_at).toLocaleDateString("fr-FR")}){f.status === "sent" ? ` · ${f.sent} envoyée(s), ${f.skipped || 0} écartée(s)` : ""}</span>
      {f.status === "scheduled" && <button onClick={cancel} className="text-muted hover:text-destructive" data-testid="lead-followup-cancel">Annuler la relance</button>}
    </div>
  );
}
